import React from "react";
import {css, cx} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";
import {ARTICLE_TEST_IDS} from "@pg-mono/test-ids";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {IArticleListArticle} from "../../actions/fetch_article_list";

interface IProps {
    className?: string;
    articleTitle: React.JSX.Element;
    imageLoading?: HTMLImageElement["loading"];
    article: IArticleListArticle;
}

export const ArticleListBoxWide = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const articleBoxHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        const linkElement = event.currentTarget.querySelector("a");

        if (linkElement && linkElement.contains(event.target as Node)) {
            return;
        }
        event.stopPropagation();
        window.open(articleLink, responsiveLinkTarget);
    };
    return (
        <div className={cx(articleListBox, props.className)} onClick={articleBoxHandler} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
            {article.gallery[0]?.image && (
                <Picture
                    className={picture}
                    sources={[
                        {
                            minWidthPX: 0,
                            src: getThumbnailLink(article.gallery[0]?.image_url, 206, 206) ?? article.gallery[0].image.g_img_206x206,
                            width: 206,
                            height: 206
                        },
                        {
                            minWidthPX: 1200,
                            src: getThumbnailLink(article.gallery[0]?.image_url, 349, 239) ?? article.gallery[0].image.g_img_349x239,
                            width: 332,
                            height: 208
                        }
                    ]}
                    alt={article.title}
                    loading={props.imageLoading}
                />
            )}

            <div className={content}>
                <Text className={metaText} as="div" variant="info_txt_2">
                    <div className={date}>{formatDate(article.update_date, dateTimeFormat.shortDate)}</div>
                    <div className={author}>{article.author.name}</div>
                </Text>
                <a className={link} href={articleLink} target={responsiveLinkTarget} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
                    {props.articleTitle}
                </a>

                <Text className={excerpt} variant="body_copy_1">
                    {article.excerpt}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = css({
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    boxShadow: "var(--shadow-2)",
    borderRadius: 2,
    backgroundColor: "#fff",
    "&:hover": {
        color: "var(--colors-secondary)",
        textDecoration: "none",
        cursor: "pointer"
    }
});

const link = css({
    "&:visited, &:hover, &:focus, &:active": {
        color: "var(--colors-secondary)",
        textDecoration: "none"
    }
});

const picture = css({
    flexShrink: 0,
    maxWidth: "160px",
    md: {
        maxWidth: "349px",
        maxHeight: "239px"
    }
});

const content = css({
    p: 1,
    md: {
        p: 2
    }
});

const metaText = css({
    mb: 2
});

const date = css({
    display: "inline-block",
    mr: 3
});

const author = css({
    display: "inline-block"
});

const excerpt = css({
    display: "none",
    md: {
        display: "block"
    }
});

export const articleListBoxTitle = css({
    fontSize: "1.519rem",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "block",
    lineClamp: 3,
    whiteSpace: "normal",
    md: {
        fontSize: "2.243rem",
        mb: 2,
        display: "block",
        lineClamp: "none",
        textOverflow: "initial"
    }
});
import React from "react";
import {css, cx} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";
import {ARTICLE_TEST_IDS} from "@pg-mono/test-ids";

import {useResponsiveLinkTarget} from "../../../hooks/use_responsive_link_target";
import {getThumbnailLink} from "../../../utils/get_thumbnail_link";
import {IArticleListArticle} from "../../actions/fetch_article_list";

interface IProps {
    className?: string;
    articleTitle: React.JSX.Element;
    imageLoading?: HTMLImageElement["loading"];
    article: IArticleListArticle;
}

export const ArticleListBoxWide = (props: IProps) => {
    const {article} = props;
    const articleLink = rpAppLink.article.detail({
        articleSlug: article.slug,
        articleId: article.id
    });
    const responsiveLinkTarget = useResponsiveLinkTarget();
    const articleBoxHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        const linkElement = event.currentTarget.querySelector("a");

        if (linkElement && linkElement.contains(event.target as Node)) {
            return;
        }
        event.stopPropagation();
        window.open(articleLink, responsiveLinkTarget);
    };
    return (
        <div className={cx(articleListBox, props.className)} onClick={articleBoxHandler} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
            {article.gallery[0]?.image && (
                <Picture
                    className={picture}
                    sources={[
                        {
                            minWidthPX: 0,
                            src: getThumbnailLink(article.gallery[0]?.image_url, 206, 206) ?? article.gallery[0].image.g_img_206x206,
                            width: 206,
                            height: 206
                        },
                        {
                            minWidthPX: 1200,
                            src: getThumbnailLink(article.gallery[0]?.image_url, 349, 239) ?? article.gallery[0].image.g_img_349x239,
                            width: 332,
                            height: 208
                        }
                    ]}
                    alt={article.title}
                    loading={props.imageLoading}
                />
            )}

            <div className={content}>
                <Text className={metaText} as="div" variant="info_txt_2">
                    <div className={date}>{formatDate(article.update_date, dateTimeFormat.shortDate)}</div>
                    <div className={author}>{article.author.name}</div>
                </Text>
                <a className={link} href={articleLink} target={responsiveLinkTarget} data-testid={ARTICLE_TEST_IDS.ARTICLE_LIST.ARTICLE_BOX}>
                    {props.articleTitle}
                </a>

                <Text className={excerpt} variant="body_copy_1">
                    {article.excerpt}
                </Text>
            </div>
        </div>
    );
};

export const articleListBox = css({
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
    boxShadow: "var(--shadow-2)",
    borderRadius: 2,
    backgroundColor: "#fff",
    "&:hover": {
        color: "var(--colors-secondary)",
        textDecoration: "none",
        cursor: "pointer"
    }
});

const link = css({
    "&:visited, &:hover, &:focus, &:active": {
        color: "var(--colors-secondary)",
        textDecoration: "none"
    }
});

const picture = css({
    flexShrink: 0,
    maxWidth: "160px",
    md: {
        maxWidth: "349px",
        maxHeight: "239px"
    }
});

const content = css({
    p: 1,
    md: {
        p: 2
    }
});

const metaText = css({
    mb: 2
});

const date = css({
    display: "inline-block",
    mr: 3
});

const author = css({
    display: "inline-block"
});

const excerpt = css({
    display: "none",
    md: {
        display: "block"
    }
});

export const articleListBoxTitle = css({
    fontSize: "1.519rem",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "block",
    lineClamp: 3,
    whiteSpace: "normal",
    md: {
        fontSize: "2.243rem",
        mb: 2,
        display: "block",
        lineClamp: "none",
        textOverflow: "initial"
    }
});
